import { OrderBookPanel } from "@/features/order-book/order-book-panel";
import { OrderFormPanel } from "@/features/order-form/order-form-panel";
import { PositionsPanel } from "@/features/positions/positions-panel";

/**
 * Custom mobile trade view that uses CSS flexbox instead of flexlayout.
 * This allows the order form to expand when TP/SL fields are shown,
 * pushing down the positions panel below (content-driven height).
 */
export const MobileTradeView = () => {
  return (
    <div className="flex flex-col h-full overflow-y-auto p-1.5 gap-1.5">
      {/* Top section: Order Book + Order Form side by side */}
      {/* items-stretch ensures both children have equal height based on the taller one */}
      <div className="flex flex-row shrink-0 gap-1.5 items-stretch min-h-[280px]">
        {/* Order Book - 40% width, h-full wrapper to fill stretched height */}
        <div className="w-[40%]">
          <div className="h-full">
            <OrderBookPanel panelId="mobile-trade-order-book" />
          </div>
        </div>
        
        {/* Order Form - 60% width, height grows with content */}
        <div className="w-[60%]">
          <OrderFormPanel panelId="mobile-trade-order-form" />
        </div>
      </div>
      
      {/* Bottom section: Positions - fills remaining space */}
      <div className="flex-1 min-h-[200px]">
        <PositionsPanel panelId="mobile-trade-positions" />
      </div>
    </div>
  );
};

